module.exports = __webpack_public_path__ + "images/landing/video-previews/Year_End_Sale_Video_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Year_End_Sale_Video_2x.jpg
// module id = TJrD
// module chunks = 1